import { getAuth, onAuthStateChanged } from "firebase/auth";
import { collection, doc, getDoc, getDocs } from "firebase/firestore";
import React, { useEffect, useState } from 'react';
import { HiChevronDoubleLeft, HiChevronDoubleRight, HiChevronLeft, HiChevronRight } from "react-icons/hi";
import { useNavigate } from 'react-router-dom';
import LoadingSpinner from '../assets/LoadingSpinner';
import '../css/InventoryProducts.css';
import { db } from "../firebase-config";

const InventoryProducts = () => {
  const navigate = useNavigate();
  const [search, setSearch] = useState('');
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [usertype, setUsertype] = useState(null);

     // Pagination state
     const [currentPage, setCurrentPage] = useState(1);
     const itemsPerPage = 20; // Adjust this value for more/less items per page

  const handleSearchChange = (e) => {
    const searchTerm = e.target.value;
    setSearch(searchTerm);

         // Reset current page when searching
         setCurrentPage(1);

    // Filter products based on search term
    if (searchTerm.trim() === '') {
      setFilteredProducts(products); // If search is empty, show all products
    } else {
      const filtered = products.filter(product =>
        product.name.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredProducts(filtered);
    }
    setCurrentPage(1); // Reset to first page on new search
  };

  const handleSearchClick = () => {
    console.log('Searching for:', search);
  };

  const handleEditClick = (id) => {
    console.log('Editing product with ID:', id);
    navigate(`/pages/EditProduct/${id}`);
  };

  const handleAddProductClick = () => {
    navigate('/pages/AddNewProduct');
  };

  useEffect(() => {
    const getProducts = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, 'products'));
        const productsArray = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        productsArray.sort((a, b) => a.name.localeCompare(b.name));
        setProducts(productsArray);
        setFilteredProducts(productsArray); // Initialize filteredProducts with all products
        setLoading(false);
      } catch (err) {
        setError('Failed to fetch products. Please try again later.');
        console.error('Error fetching products:', err);
        setLoading(false);
      }
    };
    getProducts();
  }, []);

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        // Query the users collection to get the user type
        const userDocRef = doc(db, 'users', user.uid);
        const userDoc = await getDoc(userDocRef);
        if (userDoc.exists()) {
          const userData = userDoc.data();
          setUsertype(userData.usertype);  // Set usertype based on the Firestore document
        }
      }
    });

    return () => unsubscribe();
  }, []);

      // Calculate paginated data
      const indexOfLastItem = currentPage * itemsPerPage;
      const indexOfFirstItem = indexOfLastItem - itemsPerPage;
      const currentItems = filteredProducts.slice(indexOfFirstItem, indexOfLastItem);
    
      // Total pages
      const totalPages = Math.ceil(filteredProducts.length / itemsPerPage);
    
      const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
          setCurrentPage(newPage);
        }
      };
  

  if (loading) return <LoadingSpinner isVisible={true} />;
  if (error) return <div>Error: {error}</div>;

  return (
    <>
    <div className="header-products">
      <h1 className="header-products">Products List</h1>
    </div>

    <div className="container-products">
      <div className="top-section-products">
        <div className="search-container-products">
          <input 
            type="text" 
            placeholder="Search products..." 
            value={search}
            onChange={handleSearchChange}
            className="search-box-products"
          />
        </div>
        <button onClick={handleAddProductClick} className="add-btn-products" disabled={!(usertype === "Admin")}>Add Product</button>
      </div>

      <table className="product-table">
        <thead>
          <tr>
            <th>Item Name</th>
            <th>Quantity</th>
            <th>Unit of Measurement</th>
            <th>Dealer's Price</th>
            <th>Seller's Price</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {currentItems.map(product => (
            <tr key={product.id}>
              <td>{product.name}</td>
              <td>{parseFloat(product.quantity).toFixed(2)}</td>
              <td>{product.measurement}</td>
              <td>₱{parseFloat(product.dealerPrice).toFixed(2)}</td>
              <td>₱{parseFloat(product.sellerPrice).toFixed(2)}</td>
              <td><button onClick={() => handleEditClick(product.id)} className="edit-btn-products" disabled={!(usertype === "Admin" || usertype === "Manager")}>Edit</button></td>
            </tr>
          ))}
          </tbody>
        </table>

            {/* Pagination Controls */}
            <div className="pagination-controls">
            <button className="paginationButton"
              onClick={() => handlePageChange(1)} 
              disabled={currentPage === 1}
            >
              <HiChevronDoubleLeft />
            </button>
            <button className="paginationButton"
              onClick={() => handlePageChange(currentPage - 1)} 
              disabled={currentPage === 1}
            >
              <HiChevronLeft />
            </button>
            <span>Page {currentPage} of {totalPages}</span>
            <button className="paginationButton"
              onClick={() => handlePageChange(currentPage + 1)} 
              disabled={currentPage === totalPages}
            >
              <HiChevronRight />
            </button>
            <button className="paginationButton"
              onClick={() => handlePageChange(totalPages)} 
              disabled={currentPage === totalPages}
            >
              <HiChevronDoubleRight />
            </button>
          </div>
      </div>
    </>
  );
};

export default InventoryProducts;